module.exports = __webpack_public_path__ + "img/top-arrow.92a243b3.png";